import createAction from 'redux-actions/lib/createAction';

export const PERSIST_HIDE_NAV = 'publicActions/PERSIST_HIDE_NAV';
export const setPersistHideNav = createAction(PERSIST_HIDE_NAV);
